<template>
  <section>
    <!-- BANNER -->
    <!-- BANNER -->
    <!-- <cac-header>Rowing Safety</cac-header> -->
    <!-- SB-01 -->
    <div id="sb-01" v-if="$store.state.currentLocation >= 0">
      <!-- BANNER -->
      <cac-header>Rowing Safety</cac-header>
      <content-block>
        <!-- 5-01-00 -->
        <!-- <h1 class="animated infinite bounce delay-2s">Example</h1> -->
        <h2 class="content-block__header content-block__header--red">Welcome</h2>
        <p>Hi there! It’s great that you’re interested in rowing safety.</p>
        <p>As our community grows, people with different levels of experience join the sport of rowing. This course gives you the basic knowledge you need to examine your rowing environment, ensure your personal safety, respond to safety-related situations and assist others when needed.</p> 
        <p>Are you ready to get started?</p>
        <button-sequenced class="btn-nav--red" :loc="2" link="menu">
          Let’s go
        </button-sequenced>
      </content-block>
    </div>

    <footer
      class="course-menu"
      id="menu"
      v-if="$store.state.currentLocation >= 2"
    >
      <h3>Course Menu</h3>
      <cac-menu :menuItems="$store.state.menuItems"></cac-menu>
    </footer>
  </section>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import CacHeader from '@/components/cac-components/CacHeader.vue';
import CacMenu from '@/components/cac-components/CacMenu.vue';
import BannerFullWidth from '@/components/BannerFullWidth.vue';
import ContentBlock from '@/components/ContentBlock.vue';
import ButtonSequenced from '@/components/ButtonSequenced.vue';
import AccordionIcon from '@/components/AccordionIcon.vue';
import Accordion from '@/components/Accordion.vue';

// Quiz stuff
import QuizRadio from '@/components/QuizRadio.vue';
import QuizCheckbox from '@/components/QuizCheckbox.vue';

export default {
  name: 'nccp',
  components: {
    CacHeader,
    CacMenu,
    BannerFullWidth,
    ContentBlock,
    ButtonSequenced,
    AccordionIcon,
    Accordion,
    QuizRadio
  },
  data() {
    return {
      showModal: false,
      // 3-01-03
      q01: [
        // Q1
        {
          id: 0,
          questionText: `
            <p>You’re scheduled to go out on the water with a group of beginner rowers. It’s pretty grey out, but the water is calm. The weather forecast says there’s a 20% chance of thunderstorms in about 2 hours. They’re calling for strong winds if the storm hits.</p>
            <p>Is it safe to take the group out?</p>
          `,
          questionArray: [
            'Yes. It’s safe as long as you’re back in an hour, before the storm arrives.',
            'Yes. It’s safe, since the chance of a storm is low.',
            'No. It’s too risky.',
          ],
          corrective: 'No. It’s too risky.',
          model: [],
          answer: '',
          answerText: `
            <p>Even though the storm isn’t scheduled to hit for 2 hours, weather can change quickly. A storm will create rough conditions that make it hard to get back to the dock, especially for beginner rowers.</p>
          `,
        },
      ],
    };
  },
  methods: {
    tabContent(index) {
      this.tabIndex = index;
    },
  },
};
</script>

<style lang="scss" scoped>
/*------------------------------------*\
    #PRIMARY COLOURS
  \*------------------------------------*/

/*------------------------------------*\
    #Mixins
  \*------------------------------------*/

/*------------------------------------
    #MEDIA SCREENS < 768px (#MOBILE FIRST)
  \*------------------------------------*/
.banner {
  // background-image: url('../assets/img/_chapter-headers/mbl/01-welcome-mbl.png');
  background-image: url("../assets/img/_chapter-headers/mbl/1-introduction-mbl.jpg");
  color: #000;
  background-position: center;
  padding: 60% 10%;
  &__header {
    color: #000;
  }
}

/*------------------------------------*\
    #MEDIA SCREENS > 576px (TABLETS)
  \*------------------------------------*/
@media (min-width: 576px) {
  .banner {
    // background-image: url('../assets/img/_chapter-headers/dsk/01-welcome-dsk.png');
    background-image: url("../assets/img/_chapter-headers/dsk/1-intro-dsk.jpg");
    color: #000;
    padding: 10% 10% 14%;
    background-position: center;
    &__header {
      color: #000;
    }
  }
}

/*------------------------------------*\
  #MEDIA SCREENS > 767px (TABLETS)
\*------------------------------------*/
@media (min-width: 767px) {
  // .banner {
  //   background-image: url('../assets/img/_bg/1-01-01-bg-dsk.png');
  //   color: #fff;
  //   padding: 10% 10%;
  //   background-position: center;
  //   &__header {
  //       color: #fff;
  //   }
  // }
}

/*------------------------------------*\
    #MEDIA SCREENS > 992px
    (LAPTOP, TABLET)
  \*------------------------------------*/
@media (min-width: 992px) {
}

/*------------------------------------*\
    #MEDIA SCREENS > 1200px (DESKTOP)
  \*------------------------------------*/
@media (min-width: 1200px) {
}

/*------------------------------------*\
    #MEDIA SCREENS > 1320px (DESKTOP)
  \*------------------------------------*/
@media (min-width: 1320px) {
}

/*------------------------------------*\
    #MEDIA SCREENS > 1600px (DESKTOP)
  \*------------------------------------*/
@media (min-width: 1600px) {
}
</style>
